import styled from "@emotion/styled"

const ListElevenHeader = styled.div`
  ${({ theme }) => theme.breakpoints.down("md")} {
    margin-bottom: 130px;
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    display: flex;
    align-items: center;
  }

  ${({ noSubtitle }) => noSubtitle && "justify-content: center;"}

  ${({ theme }) => theme.breakpoints.between("md", "xl")} {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 150px;
    gap: 70px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    column-gap: 70px;
    margin-bottom: 180px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    column-gap: 100px;
    margin-bottom: 200px;
  }
`

export default ListElevenHeader
